module.exports = __webpack_public_path__ + "static/img/indexItemLogo.ac889383.png";